import React, { useState } from "react";
import { Link } from "react-router-dom";
import TSP_ICONS from "../../../utils/tspIcons";

// Right-hand rail shared by the Update Journey, Your Stats and Add Journey
// screens: "Page Sections" (in-page anchors where the section lives on the
// current screen, route links otherwise) + "Quick Actions" when the caller
// passes `quickActions` (an empty list still shows the card, as for a finished
// journey; onAction runs the one that was pressed). `children` are the screen's
// own cards, shown under them (Add Journey's Actions card).
//
// `currentPage` is "journey" | "stats" | "add"; `pageRoutes` maps each to its
// URL so a section on *another* screen links across to it.
export default function JourneySectionNav({ sections, quickActions, currentPage, pageRoutes = {}, initialActive = "overview", onAction, children }) {
  const [active, setActive] = useState(initialActive);

  const renderSection = (section) => {
    const Icon = TSP_ICONS[section.icon];
    const className = section.id === active ? "active" : "";
    const content = (
      <>
        {Icon && <Icon size={16} />}
        {section.label}
      </>
    );

    if (section.to) {
      return (
        <Link to={section.to} className={className}>
          {content}
        </Link>
      );
    }
    if (section.page === currentPage) {
      return (
        <a href={`#${section.id}`} className={className} onClick={() => setActive(section.id)}>
          {content}
        </a>
      );
    }
    return (
      <Link to={`${pageRoutes[section.page]}#${section.id}`} className={className}>
        {content}
      </Link>
    );
  };

  return (
    <aside className="tsp-journey-section-nav">
      <div className="tsp-card">
        <h4 className="tsp-section-nav-title">Page Sections</h4>
        <ul className="tsp-section-nav-list">
          {sections.map((section) => (
            <li key={section.id}>{renderSection(section)}</li>
          ))}
        </ul>
      </div>

      {Array.isArray(quickActions) && quickActions.length > 0 && (
        <div className="tsp-card">
          <h4 className="tsp-section-nav-title">Quick Actions</h4>
          <div className="tsp-quick-actions-list">
            {quickActions.map((action) => (
              <button
                key={action.key}
                type="button"
                className={`tsp-btn tsp-btn-${action.tone} ${action.row === "pair" ? "" : "tsp-quick-action-full"}`}
                onClick={() => onAction?.(action.key)}
                disabled={action.disabled}
              >
                {action.label}
              </button>
            ))}
          </div>
        </div>
      )}
      {children}
    </aside>
  );
}
